<template>
<div class="container-fluid">
        <div class="herosection"
            :style="{
                backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '924px'
            }"
        >
        <NavbarSection />
        <!-- <img src="../assets/images/contact/bgOverlay.png" alt="overlay" class="overlay-img" /> -->
        <div class="heroWriteup">
            <p v-html="description"></p>
            <button class="register" @click="joinNow">
                <p style="margin: 0%; padding: 0%;">Join Now</p>
                <CircleArrowRight />
            </button>
        </div>
    </div>
    <div class="map">
        <div class="map-image">
            <!-- responsive wrapper -->
            <div style="width:100%;height:450px;padding-bottom:56%;position:relative;">
            <iframe
                src="https://www.google.com/maps?q=Lagos%20Lawn%20Tennis%20Club%20Tafawa%20Balewa%20Square%20Lagos%20Island&output=embed"
                style="border:0;position:absolute;left:0;top:0;width:100%;height:100%;"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="Lagos Lawn Tennis Club - Map">
            </iframe>
            </div>

        </div>
        <div class="map-content">
            <h2>Where to find us?</h2>
            <p>Tucked away just at the heart of Lagos , our club feels like a hidden retreat—private and exclusive, yet
                always warm and welcoming.</p>
            <P>Whether you’re ready to dive into the full experience as a Playing Member, or simply want to enjoy the
                atmosphere, community, and amenities as a Social Member, we’ve designed memberships that fit the
                lifestyle you’re looking for.</P>
            <P>Come see what makes LLTC different, you may just find your new favorite place.</P>

            <button class="register" @click="joinNow()">
                <p style="margin: 0%; padding: 0%; color: white;">Join Now</p>
                <CircleArrowRight />
            </button>
        </div>
    </div>
    <div class="person-card">
        <img :src="sub_image ? sub_image : require('../assets/images/contact/tennissection.png')" alt="">
        <div class="name-container">
            <h2>{{ sub_title }}</h2>
            <p v-html="sub_description"></p>
        </div>
    </div>
    <div class="person-card" v-if="sub_image2">
        <img :src="sub_image2" alt="">
        <div class="name-container">
            <h2>{{ sub_title2 }}</h2>
            <p v-html="sub_description2"></p>
        </div>
    </div>
    <div class="person-card" v-if="sub_image3">
        <img :src="sub_image3" alt="">
        <div class="name-container">
            <h2>{{ sub_title3 }}</h2>
            <p v-html="sub_description3"></p>
        </div>
    </div>
    <div class="person-card">
        <img :src="sub_image4" alt="" v-if="sub_image4">
        <div class="name-container">
            <h2>{{ sub_title4 }}</h2>
            <p v-html="sub_description4"></p>
        </div>
    </div>
    <div class="contact-form">
        <h2>Contact Us About Membership</h2>
        <p>Contact us today to schedule a tour, learn about membership options, or book your first tennis session at
            Lagos' premier tennis destination.</p>
        <div class="send-message">
            <h2 class="header">Send us a message</h2>
            <form @submit.prevent="submitForm">
                <div class="form-row">
                    <!-- Full Name -->
                    <div class="form-group">
                        <label for="fullname">Full Name*</label>
                        <input type="text" id="fullname" name="fullname" placeholder="Enter your full name" required v-model="fullname" />
                    </div>

                    <!-- Email -->
                    <div class="form-group">
                        <label for="email">Email*</label>
                        <input type="email" id="email" name="email" placeholder="Enter your email" required v-model="email" />
                    </div>
                </div>

                <div class="form-row">
                    <!-- Phone with Country Code -->
                    <div class="form-group">
                        <label for="phone">Phone Number*</label>
                        <input type="tel" id="phone" name="phone" placeholder="+234 800 000 0000" required v-model="phone" />
                    </div>

                    <!-- Subject -->
                    <div class="form-group">
                        <label for="subject">Subject*</label>
                        <input type="text" id="subject" name="subject" placeholder="Enter subject" required v-model="subject" />
                    </div>
                </div>

                <!-- Message -->
                <div class="form-group">
                    <label for="message">Message*</label>
                    <textarea id="message" name="message" rows="8" placeholder="Type your message here..."
                        required v-model="message"></textarea>
                </div>

                <!-- Activities (Checkboxes) -->
                <div class="form-group">
                    <label>Interests</label>
                    <div class="activities">
                        <label><input type="checkbox" name="interest[]" v-model="interest" value="tennis" /> Tennis</label>
                        <label><input type="checkbox" name="interest[]" v-model="interest" value="darts" /> Darts</label>
                        <label><input type="checkbox" name="interest[]" v-model="interest" value="squash" /> Squash</label>
                        <label><input type="checkbox" name="interest[]" v-model="interest" value="tournament" /> Tournament</label>
                        <label><input type="checkbox" name="interest[]" v-model="interest" value="coaching" /> Coaching</label>
                    </div>
                </div>

                <!-- How did you hear about us? -->
                <div class="form-group">
                    <label for="referral">How did you hear about us?</label>
                    <select id="referral" name="referral" required v-model="hear_aboutus">
                        <option value="" disabled selected>Select an option</option>
                        <option value="Walked By / Saw Signage">Walked By / Saw Signage</option>
                        <option value="Friend or Family Referral">Friend or Family Referral</option>
                        <option value="Social media (Facebook, Instagram, Twitter/X, TikTok, etc.)">Social media (Facebook, Instagram, Twitter/X, TikTok, etc.)</option>
                        <option value="Google Search">Google Search</option>
                        <option value="Online Advertisement">Online Advertisement</option>
                        <option value="Website / Blog">Website / Blog</option>
                        <option value="Newsletter Email">Newsletter Email</option>
                        <option value="Print Advertisement">Print Advertisement </option>
                        <option value="Club Events">Club Events</option>
                        <option value="Radio / TV">Radio / TV                        </option>
                        <option value="Word of Mouth by Alumni / Current Member / Parent Referral">Word of Mouth by Alumni / Current Member / Parent Referral</option>
                    </select>
                </div>

                <!-- Submit Button -->
                <button type="submit">
                    <p>Send message</p>
                    <ChevronRight />
                </button>
            </form>

        </div>
    </div>
    <FooterSection />
</div>
</template>

<script setup>
/* eslint-disable */ 
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import { CircleArrowRight, ChevronRight } from "lucide-vue-next"
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import router from "@/router";

let base_url = process.env.VUE_APP_BASE_LIVE_URL

const fullname = ref('')
const email = ref('')
const phone = ref('')
const subject = ref('')
const message = ref('')
const hear_aboutus = ref('')
const interest = ref([])

const bannerList = ref([]);
const subBannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');

const sub_image = ref('');
const sub_title = ref('');
const sub_description = ref('');

const sub_image2 = ref('');
const sub_title2 = ref('');
const sub_description2 = ref('');

const sub_image3 = ref('');
const sub_title3 = ref('');
const sub_description3 = ref('');

const sub_image4 = ref('');
const sub_title4 = ref('');
const sub_description4 = ref('');

onMounted( async () => {
  await listBanner()
  await listSubBanner()
  await listSubBanner2()
  await listSubBanner3()
  await listSubBanner4()
});

onBeforeUnmount( async () => {
  
});


const listBanner = async () => {
  try {
    const config = 'membership-info';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listSubBanner = async () => {
  try {
    const config = 'membership-info-subbanner';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    subBannerList.value = response.data.data;
    sub_title.value = subBannerList.value.title
    sub_description.value = subBannerList.value.description
    sub_image.value = `${base_url}${subBannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listSubBanner2 = async () => {
  try {
    const config = 'membership-info-subbanner2';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    subBannerList.value = response.data.data;
    sub_title2.value = subBannerList.value.title
    sub_description2.value = subBannerList.value.description
    sub_image2.value = `${base_url}${subBannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listSubBanner3 = async () => {
  try {
    const config = 'membership-info-subbanner3';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    subBannerList.value = response.data.data;
    sub_title3.value = subBannerList.value.title
    sub_description3.value = subBannerList.value.description
    sub_image3.value = `${base_url}${subBannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listSubBanner4 = async () => {
  try {
    const config = 'membership-info-subbanner4';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    subBannerList.value = response.data.data;
    sub_title4.value = subBannerList.value.title
    sub_description4.value = subBannerList.value.description
    sub_image4.value = `${base_url}${subBannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const joinNow = async() => {
    router.push(`/register`);
}
async function submitForm() {
    if (!fullname.value || !email.value || !phone.value || !subject.value || !message.value || !hear_aboutus.value || !interest.value) {
        alert("Please fill in all fields.");
        return;
    }

    const formData = new FormData();
    formData.append("fullname", fullname.value);
    formData.append("email", email.value);
    formData.append("phone", phone.value);
    formData.append("subject", subject.value);
    formData.append("message", message.value);
    formData.append("interest", interest.value);
    formData.append("hear_aboutus", hear_aboutus.value);

    try {
        const response = await axios.post(
            "/member_contactus.php", // change to your backend URL
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
              
            }
        );

            alert(response.data.message);

            fullname.value = "";
            email.value = "";
            phone.value = "";
            message.value = "";
            subject.value = "";
            hear_aboutus.value = "";
            interest.value = "";

            window.location.reload()
            
 
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}
</script>

<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/contact/contact.png');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
    /* ensures overlay image stays within bounds */
}


.heroWriteup {
    position: absolute;
    max-width: 650px;
    text-align: left;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: white;

    h2 {
        font-size: 52px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 18px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;

    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #7c7777;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 15px 25px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    /* make it cover */
    height: 100%;
    object-fit: cover;
    /* prevent distortion */
    opacity: 0.6;
    /* control transparency */
}

.map {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6rem;
    padding: 20px;
    max-width: 80%;
    margin: auto;
    margin-top: 4rem;
}

.map-image {
    flex: 1;
    max-width: 474px;
    height: 474px;
    border-radius: 5px;
    overflow: hidden;
}

.map-content {
    max-width: 523px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 10px;

    h2 {
        color: #171717;
        font-size: 48px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: left;

    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: left;
        color: #555555;
    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #7c7777;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 15px 25px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }
}

.person-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    position: relative;
}

.person-card img {
    width: 80%;
    height: 720px;
    border-radius: 20px;
    object-fit: cover;
    border: 3px solid transparent;
}

.person-card {
    position: relative;
}

.person-card .name-container {
    border: 2px solid white;
    width: 78%;
    height: 88px;
    border-radius: 12px;

    background-color: rgba(44, 43, 43, 0.2);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(6px);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 12px;
    color: white;
}

.person-card h2 {
    /* margin-top: 10px; */
    margin: 0%;
    padding: 0%;
    font-size: 16px;
    font-weight: 700px;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.person-card p {
    /* margin-top: 10px; */
    margin: 0%;
    padding: 0%;
    font-size: 13px;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.contact-form {
    background: #F6F6F6;
    margin-top: 3rem;
    padding: 4rem 30px;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 100%;
    /* margin: auto; */
}

.form-group {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    width: 100%;
    margin-bottom: 20px;
}

label {
    margin-bottom: 0.5rem;
    font-weight: 400;
    font-size: 16px;
    font-family: "Open Runde", sans-serif;
    color: #020617;
}

.form-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
}

.send-message {
    background: #fff;
    padding: 30px;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-width: 720px;
    margin: auto;

}

.send-message .header {
    text-align: left;
    margin-bottom: 1.5rem;
    font-size: 24px;
    font-weight: 400;
    font-family: "Open Runde", sans-serif;
    color: #020617;
}

.contact-form h2 {
    margin-bottom: 10px;
    font-size: 48px;
    font-weight: 400;
    font-family: "Open Runde", sans-serif;
    color: #171717;
    text-align: center;
    margin-bottom: 2rem;
}

.contact-form p {
    margin-bottom: 20px;
    color: #555555;
    font-size: 20px;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    text-align: center;
    max-width: 809px;
    margin: auto;
    margin-bottom: 5rem;
}

.send-message form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.send-message input,
.send-message textarea,
.send-message select {
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 1rem;
    width: 100%;
}

.send-message textarea {
    min-height: 100px;
    resize: vertical;
}

.activities {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    font-size: 0.95rem;
}

.activities label {
    display: flex;
    align-items: center;
    gap: 6px;
}

.send-message button {
    background: #ED4E24;
    color: #fff;
    border: none;
    padding: 14px;
    border-radius: 8px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    p {
        color: white;
        margin: 0%;
        padding: 0%;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        font-weight: 500;
    }
}

.send-message button:hover {
    background: #ED4E24;
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

    }

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }



    .heroWriteup {
        position: absolute;
        width: 100%;
        text-align: left;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 28px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }

    .map {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* gap: 6rem; */
        padding: 10px;
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .map-image {
        max-width: 100%;
        height: 20px;
        border-radius: 5px;
        overflow: hidden;
    }

    .map-content {
        max-width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        gap: 10px;

        h2 {
            color: #171717;
            font-size: 48px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;

        }

        p {
            font-size: 20px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: left;
            color: #555555;
        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }

    .person-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: all 0.3s ease;
        position: relative;
        width: 100%;
    }

    .person-card img {
        width: 100%;
        height: 720px;
        border-radius: 20px;
        object-fit: cover;
        border: 3px solid transparent;
    }

    .person-card {
        position: relative;
    }

    .person-card .name-container {
        border: 2px solid white;
        width: 100%;
        height: auto;
        border-radius: 12px;

        background-color: rgba(44, 43, 43, 0.2);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(6px);

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 12px;
        color: white;
    }

    .person-card h2 {
        /* margin-top: 10px; */
        margin: 0%;
        padding: 0%;
        font-size: 22px;
        font-weight: 700px;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    .person-card p {
        /* margin-top: 10px; */
        margin: 0%;
        padding: 0%;
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }
}

.contact-form {
    background: #F6F6F6;
    margin-top: 3rem;
    padding: 10px 6px;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 100%;
    /* margin: auto; */
}

.form-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    /* gap: 15px; */
}
</style>
